// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:23:34

export default {
  "id": "shelf-sweep",
  "slug": "shelf-sweep",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1877552b08c9460fbf9a7257c1cd484c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1877552b08c9460fbf9a7257c1cd484c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Shelf Sweep",
      "description": "Get ready to tidy up the shelves in Shelf Sweep!\nDive into a fun and addictive sorting puzzle game where your goal is to clean up messy shelves layer by layer. Only the outermost layer of items is visible—clear them by matching three identical items, and reveal the hidden treasures beneath!",
      "instructions": "Select a visible item from the outermost layer of the shelf.\nMatch three identical items to remove them from the shelf.\nUse your skills to clean up all the shelves and solve challenging puzzles!",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "logic",
        "match3",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "书架清理",
      "description": "准备好在《书架清理》中整理书架吧！\n沉浸在这款有趣且上瘾的排序解谜游戏中，你的目标是层层清理杂乱的书架。只有最外层物品可见——通过匹配三个相同的物品来清除它们，并揭示隐藏的宝藏！",
      "instructions": "从最外层的架子上选择一个可见物品。\n匹配三个相同的物品以将它们从架子上移除。\n运用你的技能清理所有架子并解决挑战性的谜题！",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "逻辑",
        "三消",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "架面掃描",
      "description": "準備整理書架吧！在《書架掃除》中享受一場好玩且上癮的排序解謎遊戲，你的目標是逐層清理亂糟糟的書架。只有最外層的物品是可見的——通過匹配三個相同的物品來清除它們，並揭露隱藏的寶藏！",
      "instructions": "選擇櫥架上最外層的可見物品。\n將三個相同的物品匹配在一起，以從櫥架上移除它們。\n使用你的技能清潔所有櫥架並解開挑戰性謎題！",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "邏輯",
        "三消",
        "匹配"
      ]
    },
    "zh-HK": {
      "title": "書架掃描",
      "description": "準備好喺《Shelf Sweep》整潔書架啦！投入一個充滿樂趣同上癮的排序謎題遊戲，你嘅目標係一層層清潔亂糟糟嘅書架。只有最外層嘅物品會見到——透過配對三個相同嘅物品清除佢哋，並揭示下面隱藏嘅寶藏！",
      "instructions": "選擇貨架上最外層的一個可見物品。\n匹配三個相同的物品以將其從架上移除。\n運用你的技巧清理所有货架，並解決挑戰性的謎題！",
      "genres": [
        "配對3"
      ],
      "tags": [
        "邏輯",
        "消消樂",
        "配對"
      ]
    },
    "ja": {
      "title": "棚の掃除",
      "description": "シェルフ・スウィープの棚を片付ける準備を！面白くて魅力的な整理パズルゲームに没頭し、手探りで棚を階層ごとに掃除することを目標にしましょう。見えるのはアイテムの最外層だけです。3つ同じアイテムを一致させてクリアし、その下に隠された宝物を解き明かしましょう！",
      "instructions": "棚の外側のレイヤーから見えるアイテムを選んでください。\n同じアイテムを3つ連続でマッチして、棚から取り除いてください。\nあなたのスキルを使ってすべての棚を片付けて、挑戦的なパズルを解いてください！",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "ロジック",
        "マッチ3",
        "マッチング"
      ]
    },
    "ko": {
      "title": "셀프 스위브",
      "description": "셀프 스위핑에서 책장을 정리할 준비되셨나요!\n추적되지 않은 책장을 층층 깊이 정리하는 재미있고 중독성이 있는 정렬 패러다임 게임에 빠져보세요. 가장 외측의 아이템만이 보이죠—동일한 세 가지 아이템을 맞추어 풀고, 아래에 숨겨진 보물을 드러내세요!",
      "instructions": "쌓이는 가장 바깥쪽 층에서 보이는 아이템을 선택하세요.\n동일한 아이템을 세 개 일치시켜 쌓이는 것에서 제거하세요.\n모든 쌓이는 것을 정리하고 도전적인 퍼즐을 해결하세요!",
      "genres": [
        "매치3"
      ],
      "tags": [
        "로직",
        "매치3",
        "매칭"
      ]
    },
    "fr": {
      "title": "Balayage d'étagère",
      "description": "Préparez-vous à-rangez les étagères dans Shelf Sweep !\nImmergez-vous dans un jeu de puzzle amusant et accrocheur où votre objectif est de nettoyer les étagères en les nettoyant couche par couche. Seulement la couche la plus externe des articles est visible — les éliminez en correspondant à trois éléments identiques, et révéléz les trésors cachés sous-jacents !",
      "instructions": "Sélectionnez un objet visible au niveau le plus externe de l'étagère.\nAlignez trois éléments identiques pour les supprimer de l'étagère.\nUtilisez vos compétences pour nettoyer toutes les étagères et résoudre des puzzles délicats !",
      "genres": [
        "Jeux de correspondance 3-3"
      ],
      "tags": [
        "logique",
        "match3",
        "correspondance"
      ]
    }
  }
};
